import * as React from 'react';
import { Icon } from '.';

interface IButtonIconProps {
  as?: any;
  active?: boolean;
  className?: string;
  disable?: boolean;
  name: IconNames;
  onClick?: EventListener;
  iconSize?: number;
  iconViewBox?: number;
  /** For use with Reach Router */
  to?: string;
  'data-testid'?: string;
}

const ButtonIconRound: React.FunctionComponent<IButtonIconProps> = ({
  as = 'button',
  active = false,
  children,
  className = '',
  disable = false,
  iconSize = 14,
  iconViewBox = 24,
  name,
  onClick,
  ...rest
}) => {
  const Component: any = { tag: as };
  return (
    <Component.tag
      className={`btn ${disable ? 'disabled' : ''} ${
        active ? 'active' : ''
      } flex items-center justify-center br-100 w2 h2 ${className}`}
      onClick={disable ? () => false : onClick}
      {...rest}
    >
      <Icon
        name={name}
        color={disable ? 'moon-gray' : 'blue'}
        size={iconSize}
        viewBox={iconViewBox}
      />
    </Component.tag>
  );
};

export default ButtonIconRound;
